import { useFormStepper } from "@/components/FormStepper/FormStepper.context"
import { useStyles } from "@/components/FormStepper/StepperControlButtons/StepperControlButtons.styles"
import { Button } from "@mantine/core"
import React from "react"

export const StepperControlButtons = () => {
    const { classes } = useStyles()
    const { toPrevStep, toNextStep, isFirstStep, isLastStep } = useFormStepper()
    return (
        <>
            {!isFirstStep && (
                <Button variant="outline" className={classes.previousButton} onClick={toPrevStep}>
                    Previous
                </Button>
            )}
            {!isLastStep && (
                <Button variant="filled" className={classes.nextButton} onClick={toNextStep} data-cy="next-step">
                    Next
                </Button>
            )}
        </>
    )
}
